import React, { useRef, useEffect, useState, useContext } from "react";
import RoundedButton from "../Buttons/RoundedButton";
import classes from "./ModalTour.module.scss";
import H1 from "../UI/Titles/H1/h1";
import { R_TOUR } from "../../constants/api";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import * as analytics from "../../helpers/analyticsHelpers";
import SystemContext from "../../context/SystemContext";

const ModalTour = ({ openModal = false, setOpenModal }) => {
  const { setRun } = useContext(SystemContext);
  const { t } = useTranslation();
  const [component, setComponent] = useState(null);
  const wrapperRef = useRef(null);
  const { session } = useSelector((state) => state.session);
  const plan_user = session && session.my_user?.typeUser;
  const useOutsideAlerter = (ref) => {
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpenModal(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  };
  useOutsideAlerter(wrapperRef);
  useEffect(() => {
    if (openModal) {
      setComponent(
        <div className={classes.Modal} ref={wrapperRef}>
          <H1>Tour Guiado</H1>
          <a
            className="mb"
            href={R_TOUR}
            download={R_TOUR}
            target="_blank"
            onClick={() => analytics.setAnalyticsTourPDFClick()}
            rel="noreferrer"
          >
            {t("global.open_tour")}
          </a>
          <RoundedButton
            text={t("global.close")}
            onClick={() => {
              setOpenModal(!openModal);
              // setRun(true);
            }}
          />
        </div>
      );
    } else {
      setComponent(null);
    }
  }, [openModal]);

  return component;
};
export default ModalTour;
